export const SCENARY_CACHE_NAME = 'knowledge-list-scenary';
